import { render, staticRenderFns } from "./CustomerGroupImage.vue?vue&type=template&id=5fa1400b&"
import script from "./CustomerGroupImage.vue?vue&type=script&lang=js&"
export * from "./CustomerGroupImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports